import component from '@/components/select/date-select/date-select'
export default {
  prop: ['startDate', 'endDate'],
  mapKey: 'dateRange',
  label: 'select.dateRange',
  default: [],
  formItem: {
    component,
    type: 'daterange',
    valueFormat: 'yyyy-MM-dd',
    startPlaceholder: 'select.startDate',
    endPlaceholder: 'select.endDate'
  }
}
